/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description BuildingLabel
 */

export enum BuildingLabel {
  APARTMENTS = 0,
  HOMES = 1,
  COMMUNITY = 2,
  DORMS = 3,
  TOWNHOUSES = 4,
  CONDOS = 5,
  CONDOMINIUMS = 6,
  LOFTS = 7,
  BEDROOMS = 8,
  ROOMS = 9,
  MILITARY_HOMES = 10,
}

Object.defineProperty(BuildingLabel, '__ENUM_NAME', {
  value: 'BuildingLabel',
  writable: false,
  configurable: false,
  enumerable: false,
})
